import {
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  InputAdornment,
  makeStyles,
  TextField,
} from "@material-ui/core";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Save,
  Done,
  Translate,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../components/Loading";
import { useGlobalSnackbar } from "../contexts/SnackbarContext";
import useApi from "../hooks/useApi";
import useQuery from "../hooks/useQuery";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles({
  content: {
    margin: "auto",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "min(20rem, 80vw)",
    margin: "auto",
  },
  cardTitle: {
    textAlign: "left",
  },
  field: {
    paddingBottom: ".5rem",
  },
  button: {
    width: "100%",
  },
  explanation: {
    fontSize: ".9rem",
    opacity: ".9",
    marginBottom: "1rem",
  },
  languageButton: {
    textTransform: "none",
    margin: "0.5rem 0.5rem 0 auto",
  },
});

const ShowButton = ({ show, onClick }) => {
  return (
    <InputAdornment position="end">
      <IconButton aria-label="toggle password visibility" onClick={onClick}>
        {!show ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  );
};

const UpdatePassword = (props) => {
  const { t, i18n } = useTranslation(["views", "common"]);
  const classes = useStyles();
  const history = useHistory();
  const { token, email, lang } = useQuery();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const setGlobalSnackbar = useGlobalSnackbar();
  const api = useApi();
  const [open, setOpen] = useState(false);
  const anchorEl = useRef();

  useEffect(() => {
    if (!lang) {
      i18n.changeLanguage("it");
    }
    const requestedLanguage = lang.split("-")[0].toLowerCase();
    if (i18n.resolvedLanguage !== requestedLanguage) {
      i18n.changeLanguage(requestedLanguage);
    }
  }, [i18n, lang]);

  const languages = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    { code: "fr", label: "Français" },
    { code: "it", label: "Italiano" },
  ];
  const currentLanguage = (
    i18n.resolvedLanguage ||
    i18n.language ||
    "it"
  ).split("-")[0];

  const updatePassword = async (e) => {
    e.preventDefault();
    if (confirmPassword !== password) {
      setGlobalSnackbar({
        open: true,
        severity: "error",
        message: `${t("common:errors.update_password")}`,
      });
      return;
    }
    setLoading(true);
    const res = await api("users/updatepassword", "POST", {
      password,
      email,
      token,
    });
    setLoading(false);
    if (res.ok === false) {
      setGlobalSnackbar({
        open: true,
        severity: "error",
        message: `${t("common:errors.general_update_password")}`,
      });
      return;
    }
    history.push("/login");
    setGlobalSnackbar({
      open: true,
      severity: "success",
      message: <>{t("common:success.update_password")}.</>,
    });
  };

  return (
    <div className={classes.content}>
      <Loading loading={loading} />
      <Card className={classes.card}>
        <div style={{ display: "flex" }}>
          <Button
            className={classes.languageButton}
            aria-controls="language-menu"
            aria-haspopup="true"
            onClick={() => setOpen(true)}
            ref={anchorEl}
            endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          >
            <Translate />
          </Button>
        </div>
        <Menu
          id="language-menu"
          anchorEl={anchorEl?.current}
          keepMounted
          open={open}
          getContentAnchorEl={null}
          onClose={() => setOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          {languages.map((lang) => (
            <MenuItem
              key={lang.code}
              selected={lang.code === currentLanguage}
              onClick={() => {
                i18n.changeLanguage(lang.code);
                setOpen(false);
              }}
            >
              {currentLanguage == lang.code ? (
                <Done fontSize="small" />
              ) : (
                <span style={{ width: 24 }} />
              )}
              {lang.label}
            </MenuItem>
          ))}
        </Menu>
        <CardHeader
          title={t("views:forgot_password.title")}
          className={classes.cardTitle}
        />
        <CardContent>
          <p className={classes.explanation}>
            {t("views:update_password.title")}
          </p>
          <form onSubmit={updatePassword}>
            <div className={classes.field}>
              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                id="Nuova Password"
                label={t("common:label.new_password")}
                required
                InputProps={{
                  endAdornment: (
                    <ShowButton
                      show={showPassword}
                      onClick={() => setShowPassword((prev) => !prev)}
                    />
                  ),
                }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className={classes.field}>
              <TextField
                fullWidth
                type={showConfirmPassword ? "text" : "password"}
                id="Conferma Password"
                label={t("common:label.confirm_password")}
                required
                InputProps={{
                  endAdornment: (
                    <ShowButton
                      show={showConfirmPassword}
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                    />
                  ),
                }}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
            <div>
              <Button
                type="submit"
                className={classes.button}
                variant="contained"
                color="primary"
                endIcon={<Save />}
              >
                {t("common:button.refresh_password")}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
export default UpdatePassword;
